import confusedIcon from '@/assets/icons/courseDescriptionPage/confusedIcon.svg';
import { Button, Typography } from '@pwskills/rachnaui';
import Image from 'next/image';
import { useContext, useState } from 'react';
import CourseDescriptionContext from '@/context/CourseDescriptionContext';
// import GetConnectedModal from './GetConnected/GetConnectedModal';
import LeadCapture from '../LeadCapture';
import { LeadCaptureEnquiryType, LeadCaptureType } from '../../../interfaces/leadCapture.enum';

const StillConfusedStrip = () => {
  const [openModal, setOpenModal] = useState(false);
  const { courseDetails } = useContext(CourseDescriptionContext);
  return (
    <div>
      <div className="bg-blue-100 flex py-[6px] gap-4 justify-center items-center z-[1] relative">
        <div className="flex gap-2 items-center">
          <Image src={confusedIcon} alt="confused Icon" className="!w-[22px] !h-[22px] " />
          <Typography
            variant="bold"
            component="body-small"
            className="!text-[10px] medium:!text-[14px]"
          >
            Still Confused? Let us clear all your queries
          </Typography>
        </div>
        <Button
          size="small"
          className="!bg-blue-600 !h-[32px] !px-4 !py-1"
          onClick={() => {
            setOpenModal(true);
          }}
        >
          Get Call Back
        </Button>
      </div>
      {openModal && (
        <LeadCapture
          courseId={courseDetails?._id}
          leadCaptureType={LeadCaptureType.MODAL}
          modelOpen={openModal}
          setModelOpen={setOpenModal}
          buttonText="Get Connected"
          img="/images/courseDescription/get-in-touch.svg"
          msgLineOne="We Got Your Response."
          msgLineTwo="Our Counsellor will reach out soon"
          type="ConnectWithCounsellor"
          enquiryType={LeadCaptureEnquiryType.PLANS_GET_CALLBACK}
          enquiryTypeNPF="Plans Get Callback"
          pageName="course_description"
          sourceName="course_description_still_confused"
        />
      )}
    </div>
  );
};

export default StillConfusedStrip;
